module.exports = __webpack_public_path__ + "img/benefit-4.5232f5e.jpg";